var HuesMdl = angular.module( 'Hues', ['Shared', 'infinite-scroll'] );